export const stages = [
  {
    name: "A1 часть 1",
    group: "A1",
    questions: [
      {
        title: "Заполните пропуски правильными формами",
        mainQuest: "გამარჯობა. მე ___ გიორგი და მე ___ სტუდენტი.",
        options: [
          "ჰქვია ... არის",
          "ქვია ... ვართ",
          "მქვია ... ხარ",
          "მქვია ... ვარ",
        ],
        answer: 4,
      },
      {
        title: "Вставьте правильную форму",
        mainQuest: "ხუთშაბათი არის კვირის ___ დღე.",
        options: ["მესამე", "მეორე", "პირველი", "მეოთხე"],
        answer: 4,
      },
      {
        title: "Согласуйте цвет и множественное число существительного",
        mainQuest: "აი ხუთი ___ ___ .",
        options: [
          "ყვითელი ბანანი",
          "ყვითელ ბანანებს",
          "ყვითლები ბანანები",
          "ყვითელი ბანანები",
        ],
        answer: 1,
      },
      {
        title: "Вставьте нужный глагол",
        mainQuest: "გუშინ ___ პარასკევი.",
        options: ["იყო", "ვიყავი", "არის", "იქნება"],
        answer: 1,
      },
      {
        title: "Переведите предложение «Завтра мне исполнится 45»",
        mainQuest: "ხვალ მე ___ ___ წლის.",
        options: [
          "ვიქნები ... ორმოცდახუთი",
          "იქნება ... ოცდათხუთმეტი",
          "ვიყავი ... ორმოცი",
          "ვარ ... ოცდახუთი",
        ],
        answer: 1,
      },
      {
        title:
          "Выберите предложение с соблюдением правильного порядка слов в предложении",
        options: [
          "რამდენი წლის ხარ შენ?",
          "წლის რამდენის შენ ხარ?",
          "ხარ რამდენის წლის შენ?",
          "რამდენი წლის შენ ხარ?",
        ],
        answer: 1,
      },
      {
        title: "Выберите правильную комбинацию числительного и глагола",
        mainQuest: "გუშინ თვის ___ დღე ___ .",
        options: [
          "პირველი ... არის",
          "მეორედ ... ვიყავი",
          "მესამე ... იქნება",
          "მეორე ... იყო",
        ],
        answer: 4,
      },
      {
        title:
          "Заполните пропуски правильным прилагательным цвета и формой будущего времени",
        mainQuest: "ხვალ ეს ___ ყვავილები ჩემი ___ .",
        options: [
          "თეთრ ... არიან",
          "თეთრები ... იყო",
          "თეთრი ... იქნება",
          "თეთრი ... იქნებიან",
        ],
        answer: 3,
      },
      {
        title: "Найдите предложение с ошибкой",
        options: [
          "ესენი არიან ჩემი მეგობრები.",
          "ვინ არის ეს კაცი?",
          "ვინ ესენი არიან?",
          "ვინ არიან ეს ადამიანები?",
        ],
        answer: 3,
      },
      {
        title: "Выберите верную комбинацию для перевода",
        mainQuest: "«Вчера был вторник, а завтра будет четверг.»",
        options: [
          "გუშინ იქნება სამშაბათი, ხვალ იყო ხუთშაბათი.",
          "გუშინ არის სამშაბათი, ხვალ ვარ ხუთშაბათი.",
          "გუშინ იყვნენ სამშაბათი, ხვალ იქნები ხუთშაბათი.",
          "გუშინ იყო სამშაბათი, ხვალ იქნება ხუთშაბათი.",
        ],
        answer: 4,
      },
      {
        title: "Заполните пропуск порядковым числительным от числа 30",
        mainQuest: "დღეს თვის ___ დღე არის.",
        options: ["ოცდამეათე", "ოცდაათის", "ოცდამეათეს", "ოცდაათი"],
        answer: 1,
      },
      {
        title: "Укажите предложение с правильным порядком слов",
        options: [
          "შენ როდის სამსახურში ხარ?",
          "როდის ხარ შენ სამსახურში?",
          "როდის შენ ხარ სამსახურში?",
          "სამსახურში როდის შენ ხარ?",
        ],
        answer: 2,
      },
      {
        title: "Выберите правильные формы для заполнения предложения",
        mainQuest: "ჩემი ___ (первая) მანქანა იყო ___ (черная).",
        options: [
          "პირველი ... შავი",
          "მესამე ... წითელი",
          "მეერთე ... შავი",
          "პირველად ... შავად",
        ],
        answer: 1,
      },
      {
        title: "Выберите правильный перевод предложения",
        mainQuest: "«Они были хорошими студентами.»",
        options: [
          "ისინი კარგი სტუდენტები იყვნენ.",
          "ისინი კარგები სტუდენტები იყვნენ.",
          "ისინი არიან კარგი სტუდენტები.",
          "ისინი იყო კარგი სტუდენტები.",
        ],
        answer: 1,
      },
      {
        title: "Выберите вариант, означающий согласие",
        mainQuest: "«Хорошо, договорились»",
        options: ["კარგო", "კარგი", "კარგად", "კარგი არის"],
        answer: 2,
      },
    ],
  },
  {
    name: "A1 часть 2",
    group: "A1",
    questions: [
      {
        title: "Переведите на грузинский",
        mainQuest: "«Куда ты идешь?»",
        options: [
          "ვისთან მიდიხარ?",
          "სად მიდიხარ?",
          "სად ხარ?",
          "რით მიდიხარ?",
        ],
        answer: 2,
      },
      {
        title:
          "Выберите верное окончание творительного падежа для ответа на вопрос",
        mainQuest: "«На чем / с помощью чего ты едешь?»",
        options: ["-დან", "-ზე", "-ით", "-ში"],
        answer: 3,
      },
      {
        title: "Выберите правильный перевод",
        mainQuest: "«Сегодня солнечная погода»",
        options: [
          "დღეს ღრუბლიანი ამინდია",
          "დღეს მზესავით ამინდია",
          "დღეს მზეში ამინდია",
          "დღეს მზიანი ამინდია",
        ],
        answer: 4,
      },
      {
        title: "Заполните пропуски правильной связкой послелогов",
        mainQuest:
          "«Летом и зимой используется послелог ___, а весной и осенью — ___»",
        options: ["-ზე / -ში", "-ში / -ზე", "-თან / -თვის", "-დან / -ამდე"],
        answer: 2,
      },
      {
        title: "Выберите правильный перевод предложения",
        mainQuest: "«5 марта я еду в Батуми»",
        options: [
          "ხუთ მარტს მივდივარ ბათუმში",
          "ხუთ მარტამდე მივდივარ ბათუმში",
          "ხუთ მარტიდან მივდივარ ბათუმში",
          "ხუთ მარტში მივდივარ ბათუმში",
        ],
        answer: 1,
      },
      {
        title: "Заполните пропуски правильной связкой послелогов",
        mainQuest: "«С 5 до 6»",
        options: ["-იდან / -ამდე", "-თან / -ზე", "-თვის / -ით", "-ში / -თან"],
        answer: 1,
      },
      {
        title:
          "Что означает глагольная приставка «ჩამო-» в сочетании с глаголом движения?",
        options: [
          "Перехожу дорогу",
          "Выхожу от собеседника",
          "Спускаюсь / приезжаю к собеседнику",
          "Поднимаюсь к собеседнику",
        ],
        answer: 3,
      },
      {
        title:
          "Как меняется значение послелога «-თან» в зависимости от контекста? Сопоставьте правильный перевод",
        mainQuest:
          "1. გიოსთან ვარ / 2. გიოსთან მივდივარ / 3. გიოსთან ერთად ვარ",
        options: [
          "1 - У Гио, 2 - Вместе с Гио, 3 - К Гио",
          "1 - К Гио, 2 - У Гио, 3 - Вместе с Гио",
          "1 - Вместе с Гио, 2 - У Гио, 3 - К Гио",
          "1 - У Гио, 2 - К Гио, 3 - Вместе с Гио",
        ],
        answer: 4,
      },
      {
        title: "Выберите правильный перевод предложения",
        mainQuest: "«Для кого это?»",
        options: [
          "საიდან არის ეს?",
          "ვისთვის არის ეს?",
          "რითი არის ეს?",
          "ვისთან არის ეს?",
        ],
        answer: 2,
      },
      {
        title: "Выберите правильный перевод",
        mainQuest: "«грузинский»",
        options: ["საქართველო", "ქართულად", "ქართული", "ქართველი"],
        answer: 3,
      },
      {
        title:
          "В грузинском языке отсутствует инфинитив. Что используется вместо него?",
        options: [
          "Личное местоимение",
          "Окончание -ში",
          "Прошедшее совершенное время",
          "Отглагольное существительное",
        ],
        answer: 4,
      },
      {
        title:
          "Какое окончание получает профессия, когда мы говорим «Я работаю (кем-то)»?",
        mainQuest: "(например: «врачом», «учителем»)",
        options: ["-იდან", "-ით", "-ზე", "-ად"],
        answer: 2,
      },
      {
        title: "Выберите верный перевод",
        mainQuest: "«Раньше я работал в школе»",
        options: [
          "ადრე მე ვმუშაობთ სკოლაში",
          "ადრე მე ვიმუშავე სკოლაში",
          "ადრე მე ვმუშაობდი სკოლაში",
          "ადრე მე ვიმუშავებ სკოლაში",
        ],
        answer: 3,
      },
      {
        title: "Переведите предложение",
        mainQuest: "«С 3 до 5 часов я буду у друга»",
        options: [
          "სამი საათით ხუთ საათით მეგობართან ვიქნები",
          "სამი საათიდან ხუთ საათამდე მეგობართან ვიქნები",
          "სამ საათამდე ხუთ საათიდან მეგობართან ვარ",
          "სამ საათში ხუთ საათზე მეგობართან ვიქნები",
        ],
        answer: 2,
      },
      {
        title: "Какое правило описывает слово «ხოლმე»?",
        options: [
          "Означает категорический отказ («никогда»)",
          "Используется только с прошедшим временем",
          "Ставится в самом начале предложения перед подлежащим",
          "Обозначает повторяемость действия",
        ],
        answer: 4,
      },
    ],
  },
  {
    name: "A1 часть 3",
    group: "A1",
    questions: [
      {
        title: "Вставьте нужный глагол",
        mainQuest:
          "ჩემი ძმა ჯერ სკოლაში _________, მე კი უნივერსიტეტში დავდივარ",
        options: ["სწავლობდი", "სწავლობენ", "ისწავლა", "სწავლობს"],
        answer: 4,
      },
      {
        title: "Вставьте нужный глагол",
        mainQuest: "დილაობით მე ყოველთვის ყავას _________.",
        options: ["ვსვამ", "ვწერ", "ვჭამ", "სვამს"],
        answer: 1,
      },
      {
        title: "Вставьте нужный глагол",
        mainQuest: "ნინო ახლა საინტერესო წიგნს _________.",
        options: ["უყურებდა", "კითხულობდა", "კითხულობს", "ვწერ"],
        answer: 3,
      },
      {
        title: "Вставьте нужный глагол",
        mainQuest: "გუშინ ჩვენ პარკში დიდხანს _________.",
        options: ["სეირნობდით", "ვსეირნობდით", "ვსეირნობთ", "ვისეირნებთ"],
        answer: 2,
      },
      {
        title: "Вставьте нужный глагол",
        mainQuest: "ხვალ საღამოს მეგობრები კინოში _________.",
        options: ["წამოვიდნენ", "წავიდნენ", "მიდიხართ", "წავლენ"],
        answer: 4,
      },
      {
        title: "Вставьте нужный глагол",
        mainQuest: "მე ხშირად _________ ჩემს ბავშვობაზე",
        options: ["ვამზადებ", "ვყიდულობ", "ვისვენებ", "ვფიქრობ"],
        answer: 4,
      },
      {
        title: "Вставьте нужный глагол",
        mainQuest: "ბავშვობაში მე დიდ ძაღლზე _________.",
        options: ["ვიოცნებებ", "ვოცნებობ", "ვოცნებობდით", "ვოცნებობდი"],
        answer: 4,
      },
      {
        title: "Вставьте нужное слово",
        mainQuest: "წვენს დალევ _________ წყალს?",
        options: ["და", "ან", "თუ", "ჰომ"],
        answer: 3,
      },
      {
        title: "Вставьте нужное слово (О чем)",
        mainQuest: "______ ფიქრობს შენი ძმა?",
        options: ["იმაზე", "რაზე", "ვის შესახებ", "ვისზე"],
        answer: 2,
      },
      {
        title: "Выберите верный вариант",
        options: [
          "შენ შესახებ",
          "ჩემი თაობაზე",
          "ჩემს შესახებ",
          "შენს თაობაზე",
        ],
        answer: 1,
      },
      {
        title: "Выберите верное время",
        mainQuest: "ოთხის ნახევარია",
        options: ["04:30", "03:04", "03:30", "04:35"],
        answer: 3,
      },
      {
        title: "Как сказать по-грузински «в 10:15»",
        options: [
          "ათის თხუთმეტ წუთზე",
          "თერთმეტის თხუთმეტ წუთში",
          "თერთმეტს რომ აკლია თხუთმეტი წუთი",
          "თერთმეტის თხუთმეტ წუთზე",
        ],
        answer: 4,
      },
      {
        title: "Вставьте правильную форму: «по средам»",
        mainQuest: "_________ აუზზე დავდივარ.",
        options: ["ოთხშაბათობით", "ოთხშაბათში", "ოთხშაბათი", "ოთხშაბათს"],
        answer: 1,
      },
      {
        title: "Вставьте правильную форму",
        mainQuest: "ნინო _________ დადის.",
        options: ["მეტროთი", "მეტროს", "მეტროით", "მეტროზე"],
        answer: 1,
      },
      {
        title: "Вставьте правильную форму",
        mainQuest: "დათო _________ წერს.",
        options: ["ფანქარით", "ფანქრის", "ფანქარს", "ფანქრით"],
        answer: 4,
      },
      {
        title: "Вставьте правильную форму",
        mainQuest: "გიო ამზადებს _________.",
        options: ["ხაჭაპურით", "ხაჭაპურს", "ხაჭაპურის", "ხაჭაპური"],
        answer: 2,
      },
      {
        title: "Вставьте правильную форму",
        mainQuest: "მაისი წელიწადის _________ თვეა",
        options: ["ხუთს", "მეხუთე", "ხუთჯერ", "ხუთი"],
        answer: 2,
      },
    ],
  },
  {
    name: "A2 часть 1",
    group: "A2",
    questions: [
      {
        title: "Вставьте нужную форму",
        mainQuest:
          "როდესაც ია უნივერსიტეტში სწავლობდა, ყოველ დილით ფეხით ______",
        options: ["წავედი", "მივდივარ", "დადიოდა", "დავდიოდი"],
        answer: 3,
      },
      {
        title: "Вставьте нужные приставки",
        mainQuest:
          "ბიჭები მეორე სართულზე ______ვიდნენ (поднялись), ხოლო გოგოები ეზოში ______ვიდნენ (спустились)",
        options: ["გა / ჩა", "ა / ჩა", "გამო / ჩა", "ა / გამო"],
        answer: 2,
      },
      {
        title: "Вставьте нужные приставки",
        mainQuest:
          "გუშინ საღამოს ირმა სახლში ______ვიდა (вошла), გიო კი ოთახიდან ______ვიდა (вышел).",
        options: ["შემო / ჩა", "შე / გამო", "გამო / ჩა", "ჩა / გა"],
        answer: 2,
      },
      {
        title: "Вставьте нужную приставку",
        mainQuest: "ნინო, სად ______ხვედი გუშინ?",
        options: ["ჩა-", "ა-", "შე-", "წა-"],
        answer: 4,
      },
      {
        title: "Вставьте нужную форму",
        mainQuest: "ბავშვობაში გიორგი ყოველთვის ადრე ______.",
        options: ["დგებოდი", "დგებოდა", "აწვა", "დგება"],
        answer: 2,
      },
      {
        title: "Вставьте нужную частицу",
        mainQuest: "გთხოვ, აქ ______ ეწევით! მოწევა აკრძალულია.",
        options: ["ვერ", "არა", "ნუ", "არ"],
        answer: 3,
      },
      {
        title: "Вставьте нужную частицу",
        mainQuest: "დღეს ძალიან ცუდად ვარ და გარეთ ______ გავდივარ.",
        options: ["არ", "არა", "ვერ", "ნუ"],
        answer: 3,
      },
      {
        title: "Вставьте нужную форму",
        mainQuest: "ის ______ ძლიერია",
        options: ["ლომით", "ლომივით", "ლომია", "ლომისავით"],
        answer: 2,
      },
      {
        title: "Вставьте нужную форму",
        mainQuest: "ეს გოგო ______ მღერის.",
        options: [
          "ვარსკვლავისავით",
          "ვარსკვლავივით",
          "ვარსკვლავით",
          "ვარსკვლავი",
        ],
        answer: 2,
      },
      {
        title: "Вставьте нужную форму",
        mainQuest: "მე ძალიან მიყვარს (მუსიკა / მოსმენა) ______",
        options: [
          "მუსიკაზე მოსმენას",
          "მუსიკა მოსმენა",
          "მუსიკის მოსმენა",
          "მუსიკით მოსმენით",
        ],
        answer: 3,
      },
      {
        title: "Вставьте нужный послелог",
        mainQuest: "ეს საჩუქარი ჩემი მეგობრის______ მივიღე (от друга).",
        options: ["გარეშე", "გამო", "-სთვის", "-გან"],
        answer: 4,
      },
      {
        title: "Вставьте нужный послелог",
        mainQuest: "მე (შენ) ______ (без тебя) ვერ წავალ კინოში",
        options: ["გარეშე", "გარდა", "უკან", "გამო"],
        answer: 1,
      },
      {
        title: "Вставьте нужный послелог",
        mainQuest: "ცუდი ამინდის ______ (из-за) სახლში დარჩნენ",
        options: ["გამო", "გარდა", "გარეშე", "უკან"],
        answer: 1,
      },
      {
        title: "Вставьте нужный послелог",
        mainQuest: "ანას ______ (кроме) ყველა მოვიდა შეხვედრაზე",
        options: ["გარეშე", "გამო", "წინ", "გარდა"],
        answer: 4,
      },
      {
        title: "Выберите правильное написание 712",
        options: [
          "შვიდათას თორმეტი",
          "შვიდასთორმეტი",
          "შვიდას თორმეტი",
          "შვიდასთორთ მეტი",
        ],
        answer: 3,
      },
      {
        title: "Вставьте нужную связку (Ни ..., ни ...)",
        mainQuest: "მან ______ ინგლისური იცის, ______ ესპანური.",
        options: ["კი ... კი", "-ც ... -ც", "არც ... არც", "არ ... არ"],
        answer: 3,
      },
    ],
  },
  {
    name: "A2 часть 2",
    group: "A2",
    questions: [
      {
        title:
          "Какой объектный префикс используется, когда действие направлено на «тебя» (ты — 2-е лицо, единственное число)?",
        options: ["გ-", "ვ-", "მ-", "ს-"],
        answer: 1,
      },
      {
        title: "Выберите правильную форму глагола",
        mainQuest: "«Они хотят отдохнуть»",
        options: ["გინდათ", "უნდათ", "უნდა", "მინდა"],
        answer: 2,
      },
      {
        title: "Выберите правильную форму глагола",
        mainQuest: "«Вы любите Грузию»",
        options: [
          "გიყვართ საქართველო",
          "მიყვარს საქართველო",
          "გვიყვარს საქართველო",
          "უყვარს საქართველო",
        ],
        answer: 1,
      },
      {
        title: "Выберите правильную форму глагола",
        mainQuest: "«У меня есть новая книга»",
        options: [
          "მაქვს ახალი წიგნი",
          "მყავს ახალი წიგნი",
          "მაქვს ახალი წიგნს",
          "აქვს ახალი წიგნი",
        ],
        answer: 1,
      },
      {
        title: "Выберите правильную форму глагола",
        mainQuest: "«У него есть собака»",
        options: ["მაქვს ძაღლი", "მყავს ძაღლი", "ჰყავს ძაღლი", "აქვს ძაღლი"],
        answer: 3,
      },
      {
        title: "Переведите глагол",
        mainQuest: "«Я не слышу / не понимаю тебя»",
        options: ["არ მესმის", "არ მახსოვს", "არ მჭირდება", "არ მენატრება"],
        answer: 1,
      },
      {
        title: "Переведите",
        mainQuest: "«Ему холодно»",
        options: ["მწყურია", "სცივა", "მცივა", "შია"],
        answer: 2,
      },
      {
        title: "Переведите",
        mainQuest: "«На мне надета куртка»",
        options: [
          "მასხია ქურთუკი",
          "მიკეთია ქურთუკი",
          "მახურავს ქურთუკი",
          "მაცვია ქურთუკი",
        ],
        answer: 4,
      },
      {
        title: "Какая форма означает «Я несу (предмет)»?",
        options: ["მიმყავს", "მივდივარ", "მიმაქვს", "მოვდივარ"],
        answer: 3,
      },
      {
        title: "Переведите",
        mainQuest: "«Мы скучаем по дому»",
        options: [
          "ჩვენ გვახსოვს სახლი",
          "ჩვენ გვჭირდება სახლი",
          "ჩვენ გვენატრება სახლი",
          "ჩვენ გვიხარია სახლი",
        ],
        answer: 3,
      },
      {
        title: "Выберите правильную форму",
        mainQuest: "«Тебе нужна эта книга?»",
        options: [
          "შენ გვჭირდება ეს წიგნი?",
          "შენ სჭირდება ეს წიგნი?",
          "შენ მჭირდება ეს წიგნი?",
          "შენ გჭირდება ეს წიგნი?",
        ],
        answer: 4,
      },
      {
        title: "Какая форма глагола означает «Я веду ребёнка ...»?",
        options: ["მიმყავს", "მიმაქვს", "მოაქვს", "მიჰყავს"],
        answer: 1,
      },
      {
        title: "Вставьте нужные формы",
        mainQuest: "გიორგის სცივა, ამიტომ მას ქურთუკი ______ და ქუდი ______",
        options: [
          "უკეთია / აცვია",
          "აცვია / ახურავს",
          "ახურავს / აცვია",
          "აცვია / უკეთია",
        ],
        answer: 2,
      },
      {
        title: "Вставьте нужную форму",
        mainQuest: "მას სათვალე ______",
        options: ["უჭირავს", "უკეთია", "აცვია", "ახურავს"],
        answer: 2,
      },
      {
        title: "Какая из комбинаций Местоимение + Глагол построена НЕВЕРНО?",
        options: [
          "მე მას ვეხმარები",
          "ჩვენ შენ გხედავთ",
          "თქვენ მე გესმით",
          "ის მე მირეკავს",
        ],
        answer: 3,
      },
    ],
  },
];
